import {
  AfterContentInit,
  Inject,
  ViewChild,
  Component,
  QueryList,
  ContentChildren,
  AfterViewInit,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatColumnDef, MatHeaderRowDef, MatRowDef, MatTable, MatTableDataSource } from '@angular/material/table';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

export type SimpleTableDialogData<T> = {
  title: string;
  datasource: MatTableDataSource<T>;
  columns: { key: string; label: string }[];
};

@Component({
  selector: 'app-simple-table-dialog',
  templateUrl: './simple-table-dialog.component.html',
  styleUrl: './simple-table-dialog.component.scss',
  standalone: false
})
export class SimpleTableDialogComponent<T> implements AfterContentInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatTable) table: MatTable<T>;

  @ContentChildren(MatHeaderRowDef) headerRowDefs: QueryList<MatHeaderRowDef>;
  @ContentChildren(MatRowDef) rowDefs: QueryList<MatRowDef<T>>;
  @ContentChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>;

  get columns() {
    return this.data.columns.map((c) => c.key);
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SimpleTableDialogData<T>,
    @Inject(L10N_LOCALE) public locale: L10nLocale
  ) {}

  ngAfterContentInit() {
    this.columnDefs.forEach((columnDef) => this.table.addColumnDef(columnDef));
    this.rowDefs.forEach((rowDef) => this.table.addRowDef(rowDef));
    this.headerRowDefs.forEach((headerRowDef) => this.table.addHeaderRowDef(headerRowDef));
  }

  ngAfterViewInit() {
    this.data.datasource.paginator = this.paginator;
  }
}
